import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';

const initialState = {
    uploadTemplate: null,
    uploadDocumentTemplate: null,
}


export const getTemplate = AsyncThunkAction('template/upload',  API_BASE_URL + ApiURLs.Template.Upload)

const templateSlice = createSlice({
    name: 'template',
    initialState: initialState,
    reducers: {
        setUploadTemplate: (state, action) => {
            state.uploadTemplate = action.payload.data
        },
        setUpdateDocumentData: (state, action) => {
            state.uploadDocumentTemplate = action.payload
        },
    },
    extraReducers: (builder) => {
        // builder
        // .addCase(saveDocuments.pending, (state, action) => {
        //     // state.userInfo.status = RequestStatus.Pending;


        // }).addCase(saveDocuments.fulfilled, (state, action) => {
        //     if (action.payload.status == 200) {

        //     }
        //     if (action.payload.status == 500) {

        //     }
        // }).addCase(saveDocuments.rejected, (state, action) => {

        // })
    }
})

export const { setUploadTemplate, setUpdateDocumentData, setDocumentListingTable } = templateSlice.actions;

export default templateSlice.reducer